// Page-lifetime handoffs, independent of an individual drawer. This is not a
// server receipt or an offline queue: only the API can accept publication.
const submissions = new Map();
const listeners = new Set();
export const submissionKey = (email, slab) => JSON.stringify([String(email).trim().toLowerCase(), slab.source, slab.id, slab.cert]);
export const readSubmission = key => submissions.get(key) || null;
export const subscribeSubmissions = listener => { listeners.add(listener); return () => listeners.delete(listener); };
function update(key, value) {
  submissions.set(key, value);
  // Keep active handoffs and the most recent outcomes, not an inventory cache.
  for (const [oldKey, old] of submissions) {
    if (submissions.size <= 100) break;
    if (old.status !== 'submitting') submissions.delete(oldKey);
  }
  for (const listener of listeners) listener();
}
export function beginSubmission(key, priceGbp) {
  if (readSubmission(key)?.status === 'submitting') throw Error('This slab is already being submitted. Wait for its existing handoff.');
  const submission = { status: 'submitting', priceGbp, message: 'Submitting your exact-price request. You can close this drawer; keep Browse Slabs open until the request is queued.' };
  update(key, submission);
  return submission;
}
export function finishSubmission(key, status, message) {
  update(key, { ...readSubmission(key), status, message });
}
